"use strict";

var _defineProperty = require("/home/node/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dataEntryToProto = exports.txToProto = exports.protoBytesToOrder = exports.orderToProtoBytes = exports.protoBytesToTx = exports.txToProtoBytes = void 0;

var wavesProto = __importStar(require("@waves/protobuf-serialization"));

var ts_lib_crypto_1 = require("@waves/ts-lib-crypto");

var marshall_1 = require("@waves/marshall");

var ts_types_1 = require("@waves/ts-types");

var generic_1 = require("./generic");

var long_1 = __importDefault(require("long"));

var invokeScriptCallSchema = Object.assign({}, marshall_1.schemas.txFields.functionCall[1]);

var recipientFromProto = function recipientFromProto(recipient, chainId) {
  if (recipient.alias) {
    return "alias:".concat(String.fromCharCode(chainId), ":").concat(recipient.alias);
  }

  var rawAddress = ts_lib_crypto_1.concat([1], [chainId], recipient.publicKeyHash);
  var checkSum = ts_lib_crypto_1.keccak(ts_lib_crypto_1.blake2b(rawAddress)).slice(0, 4);
  return ts_lib_crypto_1.base58Encode(ts_lib_crypto_1.concat(rawAddress, checkSum));
};

function txToProtoBytes(obj) {
  return new Uint8Array(wavesProto.waves.Transaction.encode(exports.txToProto(obj)).finish());
}

exports.txToProtoBytes = txToProtoBytes;

function convertNumber(n) {
  var maxJsNumber = Math.pow(2, 53) - 1;
  return n.toNumber() > maxJsNumber ? n.toString() : n.toNumber();
}

function protoBytesToTx(bytes) {
  var t = wavesProto.waves.Transaction.decode(bytes);
  var res = {
    version: t.version,
    type: typeByName[t.data],
    senderPublicKey: ts_lib_crypto_1.base58Encode(t.senderPublicKey),
    timestamp: t.timestamp.toNumber(),
    fee: convertNumber(t.fee.amount)
  };

  if (t.fee.hasOwnProperty('assetId')) {
    res.feeAssetId = ts_lib_crypto_1.base58Encode(t.fee.assetId);
  }

  if (t.hasOwnProperty('chainId')) {
    res.chainId = t.chainId;
  }

  switch (t.data) {
    case 'issue':
      res.name = t.issue.name;
      res.description = t.issue.description;
      res.quantity = convertNumber(t.issue.amount);
      res.decimals = t.issue.decimals;
      res.reissuable = t.issue.reissuable;

      if (t.issue.hasOwnProperty('script')) {
        res.script = t.issue.script && generic_1.base64Prefix(ts_lib_crypto_1.base64Encode(t.issue.script));
      }

      break;

    case 'transfer':
      res.amount = convertNumber(t.transfer.amount.amount);
      res.recipient = recipientFromProto(t.transfer.recipient, t.chainId);

      if (t.transfer.hasOwnProperty('attachment')) {
        res.attachment = t.transfer.attachment == null ? null : ts_lib_crypto_1.base58Encode(t.transfer.attachment);
      }

      if (t.transfer.hasOwnProperty('assetId')) {
        res.assetId = t.transfer.amount.assetId == null ? null : ts_lib_crypto_1.base58Encode(t.transfer.amount.assetId);
      }

      break;

    case 'reissue':
      res.quantity = convertNumber(t.reissue.assetAmount.amount);
      res.assetId = t.reissue.assetAmount.assetId == null ? null : ts_lib_crypto_1.base58Encode(t.reissue.assetAmount.assetId);
      res.reissuable = t.reissue.reissuable;
      break;

    case 'burn':
      res.amount = convertNumber(t.burn.assetAmount.amount);
      res.assetId = ts_lib_crypto_1.base58Encode(t.burn.assetAmount.assetId);
      break;

    case 'exchange':
      res.amount = convertNumber(t.exchange.amount);
      res.price = convertNumber(t.exchange.price);
      res.buyMatcherFee = convertNumber(t.exchange.buyMatcherFee);
      res.sellMatcherFee = convertNumber(t.exchange.sellMatcherFee);
      res.order1 = orderFromProto(t.exchange.orders[0]);
      res.order2 = orderFromProto(t.exchange.orders[1]);
      break;

    case 'lease':
      res.recipient = recipientFromProto(t.lease.recipient, t.chainId);
      res.amount = convertNumber(t.lease.amount);
      break;

    case 'leaseCancel':
      res.leaseId = ts_lib_crypto_1.base58Encode(t.leaseCancel.leaseId);
      break;

    case 'createAlias':
      res.alias = t.createAlias.alias;
      break;

    case 'massTransfer':
      if (t.massTransfer.hasOwnProperty('assetId')) {
        res.assetId = t.massTransfer.assetId == null ? null : ts_lib_crypto_1.base58Encode(t.massTransfer.assetId);
      }

      if (t.massTransfer.hasOwnProperty('attachment')) {
        res.attachment = t.massTransfer.attachment == null ? '' : ts_lib_crypto_1.base58Encode(t.massTransfer.attachment);
      } else res.attachment = '';

      res.transfers = t.massTransfer.transfers.map(function (_ref) {
        var amount = _ref.amount,
            recipient = _ref.recipient;
        return {
          amount: convertNumber(amount),
          recipient: recipientFromProto(recipient, t.chainId)
        };
      });
      break;

    case 'dataTransaction':
      res.data = t.dataTransaction.data.map(function (de) {
        if (de.hasOwnProperty('binaryValue')) return {
          key: de.key,
          type: 'binary',
          value: generic_1.base64Prefix(ts_lib_crypto_1.base64Encode(de.binaryValue))
        };
        if (de.hasOwnProperty('boolValue')) return {
          key: de.key,
          type: 'boolean',
          value: de.boolValue
        };
        if (de.hasOwnProperty('intValue')) return {
          key: de.key,
          type: 'integer',
          value: convertNumber(de.intValue)
        };
        if (de.hasOwnProperty('stringValue')) return {
          key: de.key,
          type: 'string',
          value: de.stringValue
        };
        return {
          key: de.key
        };
      });
      break;

    case 'setScript':
      res.script = t.setScript.script == null ? null : generic_1.base64Prefix(ts_lib_crypto_1.base64Encode(t.setScript.script));
      break;

    case 'sponsorFee':
      res.minSponsoredAssetFee = convertNumber(t.sponsorFee.minFee.amount);
      res.assetId = ts_lib_crypto_1.base58Encode(t.sponsorFee.minFee.assetId);
      break;

    case 'setAssetScript':
      res.assetId = ts_lib_crypto_1.base58Encode(t.setAssetScript.assetId);
      res.script = generic_1.base64Prefix(ts_lib_crypto_1.base64Encode(t.setAssetScript.script));
      break;

    case 'invokeScript':
      res.dApp = recipientFromProto(t.invokeScript.dApp, t.chainId);

      if (t.invokeScript.functionCall != null) {
        res.call = marshall_1.binary.parserFromSchema(invokeScriptCallSchema)(t.invokeScript.functionCall).value; //todo: export function call from marshall and use it directly
      }

      res.payment = t.invokeScript.payments.map(function (p) {
        return {
          amount: convertNumber(p.amount),
          assetId: p.assetId == null ? null : ts_lib_crypto_1.base58Encode(p.assetId)
        };
      });
      break;

    case 'updateAssetInfo':
      res.assetId = ts_lib_crypto_1.base58Encode(t.updateAssetInfo.assetId);
      res.name = t.updateAssetInfo.name;
      res.description = t.updateAssetInfo.description;
      break;

    default:
      throw new Error("Unsupported tx type ".concat(t.data));
  }

  return res;
}

exports.protoBytesToTx = protoBytesToTx;

function orderToProtoBytes(obj) {
  return wavesProto.waves.Order.encode(orderToProto(obj)).finish();
}

exports.orderToProtoBytes = orderToProtoBytes;

function protoBytesToOrder(bytes) {
  var o = wavesProto.waves.Order.decode(bytes);
  return orderFromProto(o);
}

exports.protoBytesToOrder = protoBytesToOrder;

var getCommonFields = function getCommonFields(_a) {
  var senderPublicKey = _a.senderPublicKey,
      fee = _a.fee,
      timestamp = _a.timestamp,
      type = _a.type,
      version = _a.version,
      rest = __rest(_a, ["senderPublicKey", "fee", "timestamp", "type", "version"]);

  var typename = nameByType[type];
  var chainId = rest.chainId;

  if (chainId == null) {
    var r = rest;
    var recipient = r.recipient || r.dApp || r.transfers && r.transfers[0] && r.transfers[0].recipient;

    if (recipient) {
      chainId = generic_1.chainIdFromRecipient(recipient);
    }
  }

  return {
    version: version,
    type: type,
    chainId: chainId,
    senderPublicKey: ts_lib_crypto_1.base58Decode(senderPublicKey),
    timestamp: long_1.default.fromValue(timestamp),
    fee: amountToProto(fee, rest.feeAssetId),
    data: typename
  };
};

var getIssueData = function getIssueData(t) {
  return {
    name: t.name,
    description: t.description === '' ? null : t.description,
    amount: long_1.default.fromValue(t.quantity),
    decimals: t.decimals === 0 ? null : t.decimals,
    reissuable: t.reissuable ? true : undefined,
    script: t.script == null ? null : scriptToProto(t.script)
  };
};

var getTransferData = function getTransferData(t) {
  return {
    recipient: recipientToProto(t.recipient),
    amount: amountToProto(t.amount, t.assetId),
    attachment: t.attachment == null || t.attachment == '' ? undefined : ts_lib_crypto_1.base58Decode(t.attachment)
  };
};

var getReissueData = function getReissueData(t) {
  return {
    assetAmount: amountToProto(t.quantity, t.assetId),
    reissuable: t.reissuable ? true : undefined
  };
};

var getBurnData = function getBurnData(t) {
  return {
    assetAmount: amountToProto(t.amount || t.amount, t.assetId)
  };
};

var getExchangeData = function getExchangeData(t) {
  return {
    amount: long_1.default.fromValue(t.amount),
    price: long_1.default.fromValue(t.price),
    buyMatcherFee: long_1.default.fromValue(t.buyMatcherFee),
    sellMatcherFee: long_1.default.fromValue(t.sellMatcherFee),
    orders: [orderToProto(Object.assign({
      chainId: t.chainId
    }, t.order1)), orderToProto(Object.assign({
      chainId: t.chainId
    }, t.order2))]
  };
};

var getLeaseData = function getLeaseData(t) {
  return {
    recipient: recipientToProto(t.recipient),
    amount: long_1.default.fromValue(t.amount)
  };
};

var getCancelLeaseData = function getCancelLeaseData(t) {
  return {
    leaseId: ts_lib_crypto_1.base58Decode(t.leaseId)
  };
};

var getAliasData = function getAliasData(t) {
  return {
    alias: t.alias
  };
};

var getMassTransferData = function getMassTransferData(t) {
  return {
    assetId: t.assetId == null ? null : ts_lib_crypto_1.base58Decode(t.assetId),
    attachment: t.attachment == null || t.attachment == '' ? undefined : ts_lib_crypto_1.base58Decode(t.attachment),
    transfers: t.transfers.map(massTransferItemToProto)
  };
};

var getDataTxData = function getDataTxData(t) {
  return {
    data: t.data.map(exports.dataEntryToProto)
  };
};

var getSetScriptData = function getSetScriptData(t) {
  return {
    script: t.script == null ? null : scriptToProto(t.script)
  };
};

var getSponsorData = function getSponsorData(t) {
  return {
    minFee: t.minSponsoredAssetFee === null ? amountToProto(0, t.assetId) : amountToProto(t.minSponsoredAssetFee, t.assetId)
  };
};

var getSetAssetScriptData = function getSetAssetScriptData(t) {
  return {
    assetId: ts_lib_crypto_1.base58Decode(t.assetId),
    script: t.script == null ? null : scriptToProto(t.script)
  };
};

var getInvokeData = function getInvokeData(t) {
  return {
    dApp: recipientToProto(t.dApp),
    functionCall: marshall_1.binary.serializerFromSchema(marshall_1.schemas.invokeScriptSchemaV1.schema[5][1])(t.call),
    payments: t.payment == null ? null : t.payment.map(function (_ref2) {
      var amount = _ref2.amount,
          assetId = _ref2.assetId;
      return amountToProto(amount, assetId);
    })
  };
};

var getUpdateAssetInfoData = function getUpdateAssetInfoData(t) {
  return {
    assetId: ts_lib_crypto_1.base58Decode(t.assetId),
    name: t.name,
    description: t.description === '' ? null : t.description
  };
};

exports.txToProto = function (t) {
  var common = getCommonFields(t);
  var txData;

  switch (t.type) {
    case ts_types_1.TRANSACTION_TYPE.ISSUE:
      txData = getIssueData(t);
      break;

    case ts_types_1.TRANSACTION_TYPE.TRANSFER:
      txData = getTransferData(t);
      break;

    case ts_types_1.TRANSACTION_TYPE.REISSUE:
      txData = getReissueData(t);
      break;

    case ts_types_1.TRANSACTION_TYPE.BURN:
      txData = getBurnData(t);
      break;

    case ts_types_1.TRANSACTION_TYPE.LEASE:
      txData = getLeaseData(t);
      break;

    case ts_types_1.TRANSACTION_TYPE.CANCEL_LEASE:
      txData = getCancelLeaseData(t);
      break;

    case ts_types_1.TRANSACTION_TYPE.ALIAS:
      txData = getAliasData(t);
      break;

    case ts_types_1.TRANSACTION_TYPE.MASS_TRANSFER:
      txData = getMassTransferData(t);
      break;

    case ts_types_1.TRANSACTION_TYPE.DATA:
      txData = getDataTxData(t);
      break;

    case ts_types_1.TRANSACTION_TYPE.SET_SCRIPT:
      txData = getSetScriptData(t);
      break;

    case ts_types_1.TRANSACTION_TYPE.SET_ASSET_SCRIPT:
      txData = getSetAssetScriptData(t);
      break;

    case ts_types_1.TRANSACTION_TYPE.SPONSORSHIP:
      txData = getSponsorData(t);
      break;

    case ts_types_1.TRANSACTION_TYPE.EXCHANGE:
      txData = getExchangeData(t);
      break;

    case ts_types_1.TRANSACTION_TYPE.INVOKE_SCRIPT:
      txData = getInvokeData(t);
      break;

    case ts_types_1.TRANSACTION_TYPE.UPDATE_ASSET_INFO:
      txData = getUpdateAssetInfoData(t);
      break;
  }

  return Object.assign(Object.assign({}, common), _defineProperty({}, common.data, txData));
};

var orderToProto = function orderToProto(o) {
  return {
    chainId: o.chainId,
    senderPublicKey: ts_lib_crypto_1.base58Decode(o.senderPublicKey),
    matcherPublicKey: ts_lib_crypto_1.base58Decode(o.matcherPublicKey),
    assetPair: {
      amountAssetId: o.assetPair.amountAsset == null ? null : ts_lib_crypto_1.base58Decode(o.assetPair.amountAsset),
      priceAssetId: o.assetPair.priceAsset == null ? null : ts_lib_crypto_1.base58Decode(o.assetPair.priceAsset)
    },
    orderSide: o.orderType === 'buy' ? undefined : wavesProto.waves.Order.Side.SELL,
    amount: long_1.default.fromValue(o.amount),
    price: long_1.default.fromValue(o.price),
    timestamp: long_1.default.fromValue(o.timestamp),
    expiration: long_1.default.fromValue(o.expiration),
    matcherFee: amountToProto(o.matcherFee, null),
    version: o.version,
    proofs: o.proofs.map(ts_lib_crypto_1.base58Decode)
  };
};

var orderFromProto = function orderFromProto(po) {
  return {
    version: po.version,
    senderPublicKey: ts_lib_crypto_1.base58Encode(po.senderPublicKey),
    matcherPublicKey: ts_lib_crypto_1.base58Encode(po.matcherPublicKey),
    assetPair: {
      amountAsset: po.assetPair.amountAssetId == null ? null : ts_lib_crypto_1.base58Encode(po.assetPair.amountAssetId),
      priceAsset: po.assetPair.priceAssetId == null ? null : ts_lib_crypto_1.base58Encode(po.assetPair.priceAssetId)
    },
    // @ts-ignore
    chainId: po.chainId,
    orderType: po.orderSide === wavesProto.waves.Order.Side.BUY ? 'buy' : 'sell',
    amount: convertNumber(po.amount),
    price: convertNumber(po.price),
    timestamp: po.timestamp.toNumber(),
    expiration: po.expiration.toNumber(),
    matcherFee: convertNumber(po.matcherFee.amount),
    matcherFeeAssetId: po.matcherFee.assetId == null ? null : ts_lib_crypto_1.base58Encode(po.matcherFee.assetId)
  };
};

var recipientToProto = function recipientToProto(r) {
  return {
    alias: r.startsWith('alias') ? r.slice(8) : undefined,
    publicKeyHash: !r.startsWith('alias') ? ts_lib_crypto_1.base58Decode(r).slice(2, -4) : undefined
  };
};

var amountToProto = function amountToProto(a, assetId) {
  return {
    amount: a == 0 ? null : long_1.default.fromValue(a),
    assetId: assetId == null ? null : ts_lib_crypto_1.base58Decode(assetId)
  };
};

var massTransferItemToProto = function massTransferItemToProto(mti) {
  return {
    recipient: recipientToProto(mti.recipient),
    amount: mti.amount == 0 ? null : long_1.default.fromValue(mti.amount)
  };
};

exports.dataEntryToProto = function (de) {
  return {
    key: de.key,
    intValue: de.type === 'integer' ? long_1.default.fromValue(de.value) : undefined,
    boolValue: de.type === 'boolean' ? de.value : undefined,
    binaryValue: de.type === 'binary' ? ts_lib_crypto_1.base64Decode(de.value.startsWith('base64:') ? de.value.slice(7) : de.value) : undefined,
    stringValue: de.type === 'string' ? de.value : undefined
  };
};

var scriptToProto = function scriptToProto(s) {
  return ts_lib_crypto_1.base64Decode(s.startsWith('base64:') ? s.slice(7) : s);
};

var nameByType = {
  1: 'genesis',
  2: 'payment',
  3: 'issue',
  4: 'transfer',
  5: 'reissue',
  6: 'burn',
  7: 'exchange',
  8: 'lease',
  9: 'leaseCancel',
  10: 'createAlias',
  11: 'massTransfer',
  12: 'dataTransaction',
  13: 'setScript',
  14: 'sponsorFee',
  15: 'setAssetScript',
  16: 'invokeScript',
  17: 'updateAssetInfo'
};
var typeByName = {
  'genesis': 1,
  'payment': 2,
  'issue': 3,
  'transfer': 4,
  'reissue': 5,
  'burn': 6,
  'exchange': 7,
  'lease': 8,
  'leaseCancel': 9,
  'createAlias': 10,
  'massTransfer': 11,
  'dataTransaction': 12,
  'setScript': 13,
  'sponsorFee': 14,
  'setAssetScript': 15,
  'invokeScript': 16,
  'updateAssetInfo': 17
};